import { render, staticRenderFns } from "./userdietorder.vue?vue&type=template&id=dfe2d316"
import script from "./userdietorder.vue?vue&type=script&lang=js"
export * from "./userdietorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports